<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title">
        <i class="fa-solid fa-bell"></i>
        <h2>Recent Activity</h2>
      </div>
    </div>
    <div class="card-body">
      <div v-if="activities.length > 0" class="activity-list">
        <div v-for="activity in activities" :key="activity.id" class="activity-item">
          <div class="activity-icon" :class="activity.type">
            <i :class="activity.icon"></i>
          </div>
          <div class="activity-content">
            <p>{{ activity.message }}</p>
            <small>{{ formatTimeAgo(activity.timestamp) }}</small>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        <div class="empty-icon">
          <i class="fa-solid fa-inbox"></i>
        </div>
        <p>No recent activity</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecentActivity',
  props: {
    activities: {
      type: Array,
      default: () => []
    },
    formatTimeAgo: {
      type: Function,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  background: var(--card-bg);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title i {
  font-size: 1.5rem;
  color: var(--section-icon);
}

.card-title h2 {
  margin: 0;
  color: var(--heading-color);
  font-size: 1.5rem;
}

.card-body {
  padding: 30px;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.activity-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.activity-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.activity-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.activity-icon.match {
  background: var(--approved-bg);
  color: var(--approved-color);
}

.activity-icon.player {
  background: var(--pending-bg);
  color: var(--pending-color);
}

.activity-content {
  flex: 1;
}

.activity-content p {
  margin: 0 0 4px 0;
  color: var(--heading-color);
  font-size: 0.9rem;
}

.activity-content small {
  color: var(--subtext-color);
  font-size: 0.8rem;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: var(--subtext-color);
}

.empty-state p {
  color: var(--subtext-color);
  margin: 0;
}
</style>
